<div  class="container" #projectsTable>
  @if (loadingTable) {
    <div id="loading" class="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  <!-- desktop template -->
  <div *appIsDesktop>
    @if (!loadingTable && !noResults) {
      <div id="projects-table-container" class="projects-table-container" >
        <ds-table mat-table matSort (matSortChange)="sortData($event)" [dataSource]="projectsData" [displayedColumns]="displayedColumns">
          <ng-container matColumnDef="projectOwnerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_projects_owner }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'projectOwnerName_'+i"> {{ project.projectOwnerName }} </td>
          </ng-container>
          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_companyName }} </th>
            <td mat-cell class="break-word" *matCellDef="let project;let i = dataIndex" [id]="'companyName'+i"> {{ project.companyName }} </td>
          </ng-container>
          <ng-container matColumnDef="contactName">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_contact }} </th>
            <td mat-cell class="break-word" *matCellDef="let project;let i = dataIndex" [id]="'contactName'+i"> {{ project.contactName }} </td>
          </ng-container>
          <ng-container matColumnDef="projectName">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_projectName }} </th>
            <td mat-cell class="break-word" *matCellDef="let project;let i = dataIndex" [id]="'projectName'+i"> {{ project.projectName }} </td>
          </ng-container>
          <ng-container matColumnDef="projectType">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_projectType }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'projectType_'+i" [innerHTML]="getProjectTypesDisplay(project.projectTypeIds)"></td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_date }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'date_'+i"> {{ project.date | date: dateFormat }} </td>
          </ng-container>
          <ng-container matColumnDef="lastUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_lastUpdated }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'lastUpdated_'+i"> {{ project.lastUpdated | dateAgo }} </td>
          </ng-container>
          <ng-container matColumnDef="projectStatus">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_projectStatus }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'projectStatus_'+i"> {{ statuses[project.projectStatusId] }} </td>
          </ng-container>
          <ng-container matColumnDef="estimatedSalesValue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_projects_estimatedSalesValue }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'estimatedSalesValue_'+i"> {{ project.estimatedSalesValue | currency: currencySign }} </td>
          </ng-container>
          <ng-container matColumnDef="estimatedSalesDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_projects_estimatedSalesDate }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'estimatedSalesDate_'+i"> {{ project.estimatedSalesDate }} </td>
          </ng-container>
          <ng-container matColumnDef="confidenceToClose">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_projects_confToClose }} </th>
            <td mat-cell *matCellDef="let project;let i = dataIndex" [id]="'confidenceToClose_'+i"> {{ confidenceToCloseNames[confidenceToClose[project.confidenceToCloseId]] }} </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="edit-project" mat-cell *matCellDef="let project;let i = dataIndex">
              @if (project.projectStatusId !== disabledStatus) {
                <ds-button [id]="'edit_'+i" class="edit-project-buton" size="medium" type="tertiary" variant="label-icon" icon="edit-outlined"
                  (onClick)="openEditProject(project)" iconStyle="material-icons-outlined" [label]="appStrings.button_edit">
                </ds-button>
              }
              @if (project.projectStatusId === disabledStatus) {
                <ds-button [id]="'view_'+i" class="edit-project-buton" size="medium" type="tertiary" variant="label-icon" icon="visibility"
                  (onClick)="openEditProject(project)" iconStyle="material-icons-outlined" [label]="appStrings.button_view">
                </ds-button>
              }
            </td>
          </ng-container>
        </ds-table>
        @if (projectsTotal > 0) {
          <div class="pagination-container">
            <div class="page-count">
              <b>{{ pageOffset + 1 }} - {{ pageOffset + currentPageItemCount }}</b> {{appStrings.pagination_of}} <b>{{ projectsTotal }}</b>
            </div>
            <div class="pagination">
              <ds-pagination
                [totalPages]="totalPages"
                paginationDisplay="large"
                buttonTypes="nextPrevFirstLast"
                (pageChanged)="pageChanged($event)"
              ></ds-pagination>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- mobile template -->
  <div *appIsMobile class="mobile">
    @if (!loadingTable && !noResults) {
      <div>
        @for (project of projectsData; track project; let i = $index) {
          <mat-expansion-panel class="mobile-card two-columns grey blue-border" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title id="project-card-header-container" class="card-header-container">
                <span class="card-header">
                  <span id="project-card-title" class="title">
                    {{ project.companyName }}
                  </span>
                </span>
                <span class="card-header-action">
                  @if (project.projectStatusId !== disabledStatus) {
                    <ds-button [id]="'edit_'+i" size="medium" type="tertiary"
                      variant="icon-only" icon="edit-outlined" (onClick)="openEditProject(project)" iconStyle="material-icons-outlined">
                    </ds-button>
                  }
                  @if (project.projectStatusId === disabledStatus) {
                    <ds-button [id]="'view_'+i" size="medium" type="tertiary"
                      variant="icon-only" icon="visibility" (onClick)="openEditProject(project)" iconStyle="material-icons-outlined">
                    </ds-button>
                  }
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <div class="column">
                  <typography [id]="'owner_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_owner }} </typography>
                  <typography [id]="'owner_'+i" class="break-word"variant="body-2" weight="medium"> {{ project.projectOwnerName }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'contact_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_contact }} </typography>
                  <typography [id]="'contact_'+i" class="break-word" variant="body-2" weight="medium"> {{ project.contactName }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'projectName_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_projectName }} </typography>
                  <typography [id]="'projectName_'+i" class="break-word" variant="body-2" weight="medium"> {{ project.projectName }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'projectType_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_projectType }} </typography>
                  <typography [id]="'projectType_'+i" class="project-types" variant="body-2" weight="medium" [innerHTML]="getProjectTypesDisplay(project.projectTypeIds)"></typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'date_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_date }} </typography>
                  <typography [id]="'date_'+i" variant="body-2" weight="medium"> {{ project.date | date: dateFormat }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'lastUpdated_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_lastUpdated }} </typography>
                  <typography [id]="'lastUpdated_'+i" variant="body-2" weight="medium"> {{ project.lastUpdated | dateAgo }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'projectStatus_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_projectStatus }} </typography>
                  <typography [id]="'projectStatus_'+i" variant="body-2" weight="medium"> {{ statuses[project.projectStatusId] }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'confidenceToClose_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_confidenceToClose }} </typography>
                  <typography [id]="'confidenceToClose_'+i" variant="body-2" weight="medium"> {{ confidenceToCloseNames[confidenceToClose[project.confidenceToCloseId]] }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'estimatedSalesValue_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_estimatedSalesValue }} </typography>
                  <typography [id]="'estimatedSalesValue_'+i" variant="body-2" weight="medium"> {{ project.estimatedSalesValue | currency: currencySign }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'estimatedSalesDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_projects_estimatedSalesDate }} </typography>
                  <typography [id]="'estimatedSalesDate_'+i" variant="body-2" weight="medium"> {{ project.estimatedSalesDate }} </typography>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }
        @if (projectsTotal > 0) {
          <div class="pagination-container">
            <div class="pagination">
              <ds-pagination
                [totalPages]="totalPages"
                paginationDisplay="small"
                buttonTypes="nextPrevFirstLast"
                (pageChanged)="pageChanged($event)"
              ></ds-pagination>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

@if (noResults) {
  <div id="noResults" class="no-results">
    <typography variant="mat-subtitle-1" weight="regular">
      {{ appStrings.leads_noResults }}
    </typography>
  </div>
}

@if (loading) {
  <div class="overlay full"  id="projects-table-loadingSpinner">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}